import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/system/indices/ranges", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function rebuildIndexSet(indexSetId, requestOptions) {
  return __request__("POST", `/system/indices/ranges/index_set/${indexSetId}/rebuild`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function rebuild(requestOptions) {
  return __request__("POST", "/system/indices/ranges/rebuild", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function rebuildIndex(index, requestOptions) {
  return __request__("POST", `/system/indices/ranges/${index}/rebuild`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function show(index, requestOptions) {
  return __request__("GET", `/system/indices/ranges/${index}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
